import React from 'react';
import { IconProps } from '../types';
const MinecraftNetheriteBoots: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="3" width="1" height="1" fill="rgba(49, 40, 40, 255)" />
<rect x="4" y="3" width="1" height="1" fill="rgba(36, 31, 32, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(36, 31, 32, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(49, 40, 40, 255)" />
<rect x="3" y="4" width="1" height="1" fill="rgba(36, 31, 32, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(118, 106, 118, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(36, 31, 32, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(36, 31, 32, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(118, 106, 118, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(23, 17, 17, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(36, 31, 32, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(93, 86, 93, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(36, 31, 32, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(36, 31, 32, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(77, 73, 77, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(23, 17, 17, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(36, 31, 32, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(93, 86, 93, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(71, 62, 63, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(23, 17, 17, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(36, 31, 32, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(71, 62, 63, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(77, 73, 77, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(23, 17, 17, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(36, 31, 32, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(77, 73, 77, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(77, 73, 77, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(23, 17, 17, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(36, 31, 32, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(77, 73, 77, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(77, 73, 77, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(23, 17, 17, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(36, 31, 32, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(77, 73, 77, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(77, 73, 77, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(23, 17, 17, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(36, 31, 32, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(77, 73, 77, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(77, 73, 77, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(23, 17, 17, 255)" />
<rect x="2" y="9" width="1" height="1" fill="rgba(36, 31, 32, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(77, 73, 77, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(77, 73, 77, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(71, 62, 63, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(23, 17, 17, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(36, 31, 32, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(71, 62, 63, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(77, 73, 77, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(71, 62, 63, 255)" />
<rect x="13" y="9" width="1" height="1" fill="rgba(23, 17, 17, 255)" />
<rect x="1" y="10" width="1" height="1" fill="rgba(36, 31, 32, 255)" />
<rect x="2" y="10" width="1" height="1" fill="rgba(77, 73, 77, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(77, 73, 77, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(71, 62, 63, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(53, 45, 45, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(23, 17, 17, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(36, 31, 32, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(53, 45, 45, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(71, 62, 63, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(77, 73, 77, 255)" />
<rect x="13" y="10" width="1" height="1" fill="rgba(71, 62, 63, 255)" />
<rect x="14" y="10" width="1" height="1" fill="rgba(23, 17, 17, 255)" />
<rect x="1" y="11" width="1" height="1" fill="rgba(36, 31, 32, 255)" />
<rect x="2" y="11" width="1" height="1" fill="rgba(71, 62, 63, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(71, 62, 63, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(53, 45, 45, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(23, 17, 17, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(23, 17, 17, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(23, 17, 17, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(23, 17, 17, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(71, 62, 63, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(71, 62, 63, 255)" />
<rect x="13" y="11" width="1" height="1" fill="rgba(53, 45, 45, 255)" />
<rect x="14" y="11" width="1" height="1" fill="rgba(23, 17, 17, 255)" />
<rect x="1" y="12" width="1" height="1" fill="rgba(36, 31, 32, 255)" />
<rect x="2" y="12" width="1" height="1" fill="rgba(23, 17, 17, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(23, 17, 17, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(23, 17, 17, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(23, 17, 17, 255)" />
<rect x="12" y="12" width="1" height="1" fill="rgba(23, 17, 17, 255)" />
<rect x="13" y="12" width="1" height="1" fill="rgba(23, 17, 17, 255)" />
<rect x="14" y="12" width="1" height="1" fill="rgba(23, 17, 17, 255)" />
</svg>);
export default MinecraftNetheriteBoots;